module.exports = __webpack_public_path__ + "img/md-list-box.78dd3282.svg";